import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { Table, TableRow } from '@features/powerpoint';
import {
  INDEX_WIDTH,
  NORMAL_WIDTH,
  ROWS_PER_TABLE,
  headersToTableRow,
  defaultTableOptions,
  cellOptionsByIndex,
  VISIT_INDEX_WIDTH,
} from './table-utils';
import { sortBy } from '@utils/arrays';

const headers = ['', 'DMA', 'Visit Index'].map(header => header.toUpperCase());

export const dmasTable = (
  dmaVisits: CampaignAnalyticsReport['dmaVisits']
): Table => {
  const topDmasRows: TableRow[] = dmaVisits.data
    .toSorted(sortBy('visitIndex', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((dmaVisit, index): TableRow => {
      const options = cellOptionsByIndex(index);

      return [
        {
          text: (index + 1).toString(),
          options: {
            ...options,
            color: theme.colors.lightBlue,
            align: 'center',
          },
        },
        {
          text: dmaVisit.location,
          options: {
            ...options,
            bold: true,
          },
        },
        {
          text: dmaVisit.visitIndex.toString(),
          options: {
            ...options,
            align: 'center',
          },
        },
      ];
    });

  return {
    tableRows: [headersToTableRow(headers), ...topDmasRows],
    options: {
      ...defaultTableOptions,
      x: 3.71,
      colW: [INDEX_WIDTH, NORMAL_WIDTH, VISIT_INDEX_WIDTH],
    },
  };
};
